import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Steps } from 'primereact/steps';
import { useState } from 'react';
import FormCrearProductoFicha from "./FormCrearProductoFicha";
import { Dropdown } from 'primereact/dropdown';

const FormEditarProducto = ({
    showEditDialog,
    setShowEditDialog,
    descripcion,
    idTipo, 
    union,
    id,
    setDescripcion,
    metraje,
    setMetraje,
    adyacentes,
    setAdyacentes,
    productos,
    loading,
    handleSaveProducto,
    handleDeleteUnionProducto,
    selectedProduct,
    fichaRef,
    producto,
    setProducto,
    tipoProductoOptions
}) => {
    // Filtrar productos disponibles (excluir solo el producto actual)
    const productosDisponibles = productos ? productos.filter(p => p.id !== selectedProduct?.id) : [];
    const [activeStep, setActiveStep] = useState(0);
    const stepsItems = [{ label: "Producto", command: () => setActiveStep(0) },{ label: "Ficha técnica", command: () => setActiveStep(1) },];
    const handleStepChange = (e) => {setActiveStep(e.index);};
    // Convertir adyacentes a objetos completos si solo son IDs
    const adyacentesCompletos = adyacentes ? adyacentes.map(adj => {
        // Si adj ya es un objeto completo con descripcion, devolverlo tal como está
        if (typeof adj === 'object' && adj !== null && adj.descripcion) {
            return adj;
        }
        // Si adj es solo un ID o un objeto con solo ID, buscar el objeto completo
        const idAdyacente = typeof adj === 'object' && adj !== null ? adj.id : adj;
        const productoEncontrado = productos?.find(p => p.id === idAdyacente);
        return productoEncontrado || null;
    }).filter(Boolean) : [];
    
    // Crear opciones que incluyan productos disponibles Y productos ya seleccionados
    const mapaProductos = new Map();
    
    // Agregar productos disponibles
    productosDisponibles.forEach(producto => {
        mapaProductos.set(producto.id, producto);
    });
    
    // Agregar productos ya seleccionados
    adyacentesCompletos.forEach(producto => {
        mapaProductos.set(producto.id, producto);
    });
    
    const opcionesMultiSelect = Array.from(mapaProductos.values());
    
    const handleSaveClick = async () => {
      try {
        // Primero guardar los datos básicos del producto
        await handleSaveProducto();
      } catch (error) {
        console.error("Error al guardar:", error);
        alert("Error al actualizar el producto: " + error.message);
      }
    };
    // FOOTER EDITAR PROD
    const footerEditarProd  = () => {
        return (
          <div className="p-d-flex p-jc-end mt-3">
              {union && (
                <Button
                  label="Eliminar Union"
                  icon="pi pi-times"
                  onClick={handleDeleteUnionProducto}
                  className="p-button p-mr-2 p-button-danger p-button-rounded p-button"
                  raised
                  disabled={loading}
                />
              )}

              <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={() => setShowEditDialog(false)}
                className="p-button p-mr-2 p-button-outlined p-button-rounded"
                disabled={loading}
              />
              <Button
                label="Guardar"
                icon={loading ? "pi pi-spin pi-spinner" : "pi pi-save"}
                onClick={handleSaveClick}
                autoFocus
                className="p-button-success p-button-rounded p-button"
                raised
                disabled={loading}
              />
          </div>
        );
    };
    
    return (
      <div className="form-container">
        <Dialog
          visible={showEditDialog}
          footer={footerEditarProd()}
          onHide={() => setShowEditDialog(false)}
          className="p-fluid product-dialog"
          header="Editar Producto"
        >

          <Steps 
              model={stepsItems} 
              activeIndex={activeStep} 
              onSelect={handleStepChange}
              className="cursor-pointer"
              style={{ cursor: 'pointer' }}
              readOnly={false}
          />

          {activeStep === 0 && (
            <div className="card">
              <h6 className="mb-3">
                  Información del Producto
              </h6>
              {/* Tipo de Producto */}
              <span className="p-float-label mt-2 mb-3">
                  <Dropdown
                      id="tipoProducto"
                      value={producto.idTipo ?? (idTipo != null ? Number(idTipo) : null)}
                      options={tipoProductoOptions}
                      optionLabel="descripcion"
                      optionValue="id"
                      onChange={(e) => {
                          if (e.value == null) {
                              setProducto({
                                  ...producto,
                                  idTipo: null,
                                  tipoProducto: null,
                                  productosAdyacentes: [] // Limpiar productos adyacentes al cambiar tipo
                              });
                              return;
                          }
                          const selectedObj = tipoProductoOptions.find(tp => tp.id === e.value) || null;
                          setProducto({
                              ...producto,
                              idTipo: e.value,
                              tipoProducto: selectedObj, // conserva el objeto completo si se usa en otro lado
                              productosAdyacentes: [] // Limpiar productos adyacentes al cambiar tipo
                          });
                      }}
                      placeholder="Seleccione el tipo de producto"
                      required
                  />
                  <label htmlFor="tipoProducto">
                      <i className="pi pi-tag mr-2"></i>Tipo de Producto *
                  </label>
              </span>

              {/* descripcion */}
              <span className="p-float-label mt-2 mb-3">
                <InputText
                  id="descripcion"
                  value={descripcion}
                  onChange={(e) =>setDescripcion(e.target.value.toUpperCase())}
                  className="p-inputtext-lg"
                  placeholder="Ingrese la descripción del producto"
                  max={35}
                />
                <label htmlFor="descripcion"><i className="pi pi-file-edit mr-2"></i>Descripción</label>
              </span>
              {/* metraje */}
              <span className="p-float-label mt-2 mb-3">
                <InputNumber
                  id="metraje"
                  value={metraje}
                  onChange={(e) => setMetraje(e.value)}
                  className="p-inputtext-lg"
                  placeholder="Ingrese el metraje"
                  min={0}
                  max={10000}
                  locale="es-ES"
                  inputMode="decimal"
                  minFractionDigits={0}
                  maxFractionDigits={2}
                  //disabled
                />
                <label htmlFor="metraje"><i className="pi pi-th-large mr-1"></i>Metraje (m²)</label>
              </span>

              {/* cambiar productos adyacentes */}
              <span className="p-float-label">
                <MultiSelect
                  id="adyacente"
                  value={adyacentesCompletos}
                  onChange={(e) => {
                    console.log('MultiSelect onChange:', e.value);
                    setAdyacentes(e.value);
                  }}
                  options={opcionesMultiSelect}
                  optionLabel="descripcion"
                  placeholder="Seleccione productos adyacentes"
                  className="p-inputtext-lg"
                  display="chip"
                  filter
                  showClear
                />
                <label htmlFor="adyacente"><i className="pi pi-tags mr-1"></i>Productos Adyacentes</label>
              </span>

              <div
                className="mt-3 mb-3"
                style={{
                  padding: '0.75rem 1rem',
                  borderRadius: '6px',
                  backgroundColor: '#fff8e1',
                  border: '1px solid #ffe082',
                  color: '#8a6d3b'
                }}
              >
                <div className="mb-2">
                  <i className="pi pi-info-circle mr-2"></i>
                  Para gestionar los remarcadores del producto, debes hacerlo desde la app de medidores.
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" className="mt-3" onClick={() => setActiveStep(1)}/>
              </div>
            </div>
            
          )}
          {activeStep === 1 && (
            <div className="card">
              <FormCrearProductoFicha 
                  ref={fichaRef} 
                  idProducto={id} 
                  isEditing={true} 
              />
              <div className="flex-space-between">
                <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
              </div>
            </div>
          )}
        </Dialog>
      </div>
    );
};

export default FormEditarProducto;
